import * as React from 'react';
import { MarkdownBody } from './MarkdownBody';

/** Renders a CMS `Service.body` (Markdown) on the blue services surface.
 *  Thin wrapper over MarkdownBody — keeps the services layout (top margin +
 *  max width) and pins the surface to "blue". */
export function ServiceBody({ body }: { body: string }) {
  return (
    <div className="mt-8 max-w-2xl">
      <MarkdownBody body={body} surface="blue" />
    </div>
  );
}
